import {
  AfterViewInit,
  Component,
  HostBinding,
  OnInit,
  TemplateRef,
  ViewChild,
  inject
} from '@angular/core';
import { FilteringLogic, IgxStringFilteringOperand } from '@infragistics/igniteui-angular/core';
import {
  IGridEditDoneEventArgs, IGridEditEventArgs, IgxColumnComponent, IgxExcelExporterService, IgxPdfExporterService,
  IgxGridCell, IgxGridStateDirective, RowType
} from '@infragistics/igniteui-angular/grids/core';
import { IGX_GRID_DIRECTIVES, IgxGridComponent, IgxGridModule } from '@infragistics/igniteui-angular/grids/grid';
import { IgxIconComponent } from '@infragistics/igniteui-angular/icon';
import { IgxButtonDirective, IgxButtonModule, IgxFocusDirective, IgxRippleDirective, IgxRippleModule, IgxTextSelectionDirective } from '@infragistics/igniteui-angular/directives';
import {
  IGX_INPUT_GROUP_DIRECTIVES,
  IgxInputGroupComponent,
  IgxSuffixDirective
} from '@infragistics/igniteui-angular/input-group';
import { IGX_ACTION_STRIP_DIRECTIVES, IgxActionStripModule } from '@infragistics/igniteui-angular/action-strip';
import {ClsConfig} from '../../../util/cls-config';
import {MasOpcionesGridComponent} from '../../util/controles/mas-opciones-grid/mas-opciones-grid.component';
import {ClsUtil} from '../../../util/cls-util';
import {AppPresupuestosService} from '../../../core/services/app-presupuestos.service';
import {ClsObjCrudCatalogos} from '../../../clases-pu/02-catalogos/cls-obj-crud-catalogos';
import {EnumMasOpciones} from '../../../core/models/enum/enum-mas-opciones';
import {INeodataGridCell, INeodataMenu} from '../../../core/models/interfaces/generico-interface';
import {EnumMCGenerales} from '../../../core/models/enum/enum-menu-contextual';
import {TresPuntosComponent} from '../../util/controles/tres-puntos/tres-puntos.component';
import {EnumNombresGrids} from '../../../core/models/enum/enum-nombres-grids';
import {ClsObjConfiguracionGrid} from '../../../clases-pu/util/cls-obj-configuracion-grid';
import {ClsObjGenerico} from '../../../clases-pu/util/cls-obj-generico';
import {EnumTresPuntos} from '../../../core/models/enum/enum-tres-puntos';
import {VtnGenericaComponent} from '../../util/ventanas/vtn-generica/vtn-generica.component';
import {DetalleEmpresaComponent} from '../../util/ventanas/detalle/detalle-empresa/detalle-empresa.component';
import {ClsObjCopiado} from '../../../clases-pu/01-presupuesto/copiado/cls-obj-copiado';
import {DetallePegadoComponent} from '../../util/ventanas/detalle-pegado/detalle-pegado.component';
import {FiltroGeneralModernoComponent} from '../../util/controles/filtro-general-moderno/filtro-general-moderno.component';
import {ClsObjPegado} from '../../../clases-pu/99-herramientas/pegado/cls-obj-pegado';
import {TranslateModule} from '@ngx-translate/core';
import {ContextMenuGenericoComponent} from '../../util/controles/context-menu-generico/context-menu-generico.component';
import {BtnUrlContenidoComponent} from '../../util/controles/btn-url-contenido/btn-url-contenido.component';
import {UppercaseDirective} from '../../../core/directivas/uppercase.directive';
import {FormsModule} from '@angular/forms';
import {PasteHandlerNeodataDirective} from '../../../core/directivas/paste-handler-neodata.directive';
import {ClsCiudades, ClsEmpresas, ClsResponsables} from 'src/app/core/models/cls-catalogos';
import {ClsColDetallePegado} from 'src/app/core/models/cls-pegado';
import {TipoMensajesService} from "../../../core/services/tipo-mensajes.service";
import {SummaryPipeNeoPipe} from "../../../core/pipes/summary-pipe-neo.pipe";
import {CrearComponenteDinamicoService} from "../../../core/services/crear-componente-dinamico.service";

@Component({
  selector: 'app-empresas',
  templateUrl: './empresas.component.html',
  styleUrls: ['./empresas.component.scss'],
  imports: [
    IgxGridModule,
    IGX_GRID_DIRECTIVES,
    TranslateModule,
    FiltroGeneralModernoComponent,
    IgxIconComponent,
    MasOpcionesGridComponent,
    PasteHandlerNeodataDirective,
    IGX_INPUT_GROUP_DIRECTIVES,
    UppercaseDirective,
    FormsModule,
    IgxTextSelectionDirective,
    IgxFocusDirective,
    BtnUrlContenidoComponent,
    IgxActionStripModule,
    IGX_ACTION_STRIP_DIRECTIVES,
    IgxButtonModule,
    IgxButtonDirective,
    IgxRippleModule,
    IgxRippleDirective,
    ContextMenuGenericoComponent,
    SummaryPipeNeoPipe,
    IgxInputGroupComponent,
    IgxSuffixDirective
  ],
  providers: [SummaryPipeNeoPipe]
})
export class EmpresasComponent extends ClsConfig implements OnInit, AfterViewInit {
  private infPpto = inject(AppPresupuestosService);
  private tipoMsg = inject(TipoMensajesService);
  private summaryPipe = inject(SummaryPipeNeoPipe);
  private excelExportService = inject(IgxExcelExporterService);
  private pdfExportService = inject(IgxPdfExporterService);
  private crearCompDinamico = inject(CrearComponenteDinamicoService);

  @ViewChild('gridEmpresas', {read: IgxGridComponent, static: true})
  public gridEmpresas: IgxGridComponent;
  @ViewChild('masOpcionesG', {read: MasOpcionesGridComponent, static: true})
  public masOpcionesG: MasOpcionesGridComponent;
  @ViewChild('filtroGeneral', {read: FiltroGeneralModernoComponent, static: true})
  public filtroGeneral: FiltroGeneralModernoComponent;
  // ajuste de texto
  @HostBinding('class') public themesClass = 'noAjustarTexto';
  public clicked = false;

  public tresPuntosCiudad: TresPuntosComponent;
  public tresPuntosResp: TresPuntosComponent;

  public errorAlCargar: boolean;
  public dataEmpresas: ClsEmpresas[] = [];
  public activarBotones = false;
  // mostrar actionStrip
  public showActionStrip = true;
  // clase catalogos
  public mObjCRUDCatalogos: ClsObjCrudCatalogos = new ClsObjCrudCatalogos();
  private mObjGenerico: ClsObjGenerico = new ClsObjGenerico();
  private mObjCopiado: ClsObjCopiado = new ClsObjCopiado();
  private mObjPegado: ClsObjPegado = new ClsObjPegado();
  // Grid Layout
  public mObjConfigGrids: ClsObjConfiguracionGrid = new ClsObjConfiguracionGrid();
  // menucontextual
  public verContextMenu = false;
  public contextmenuX = 0;
  public contextmenuY = 0;
  public cellMenuContextaul: IgxGridCell;
  public menus: INeodataMenu[] = [];
  public lengthMenu: number;
  public subMenusOpciones: any[];
  public sizeMenu = '';
  // CONFIGGRIDS: definir cada ng-Template que tengamos en el HTML
  @ViewChild('empresaHeaderTemplate', {static: true}) public empresaTemplate: TemplateRef<any>;
  @ViewChild('empresaEditorTemplate', {static: true}) public empresaEditorTemplate: TemplateRef<any>;
  @ViewChild('razonSocialEmpresaHeaderTemplate', {static: true}) public razonSocialEmpresaTemplate: TemplateRef<any>;
  @ViewChild('razonSocialEmpresaEditorTemplate', {static: true}) public razonSocialEmpresaEditorTemplate: TemplateRef<any>;
  @ViewChild('descripcionCiudadEditorTemplate', {static: true}) public descripcionCiudadEditorTemplate: TemplateRef<any>;
  @ViewChild('direccionEmpresaEditorTemplate', {static: true}) public direccionEmpresaEditorTemplate: TemplateRef<any>;
  @ViewChild('coloniaEditorTemplate', {static: true}) public coloniaEditorTemplate: TemplateRef<any>;
  @ViewChild('nombreResponsableEditorTemplate', {static: true}) public nombreResponsableEditorTemplate: TemplateRef<any>;
  @ViewChild('telefonoEmpresaEditorTemplate', {static: true}) public telefonoEmpresaEditorTemplate: TemplateRef<any>;
  @ViewChild('rfcEmpresaEditorTemplate', {static: true}) public rfcEmpresaEditorTemplate: TemplateRef<any>;
  @ViewChild('cpEmpresaEditorTemplate', {static: true}) public cpEmpresaEditorTemplate: TemplateRef<any>;
  @ViewChild('cMICEmpresaEditorTemplate', {static: true}) public cMICEmpresaEditorTemplate: TemplateRef<any>;
  @ViewChild('faxEmpresaEditorTemplate', {static: true}) public faxEmpresaEditorTemplate: TemplateRef<any>;
  @ViewChild('iMSSEmpresaEditorTemplate', {static: true}) public iMSSEmpresaEditorTemplate: TemplateRef<any>;
  @ViewChild('infonavitEmpresaEditorTemplate', {static: true}) public infonavitEmpresaEditorTemplate: TemplateRef<any>;
  @ViewChild('mailEmpresaEditorTemplate', {static: true}) public mailEmpresaEditorTemplate: TemplateRef<any>;
  @ViewChild('sitioWebEditorTemplate', {static: true}) public sitioWebEditorTemplate: TemplateRef<any>;
  @ViewChild(IgxGridStateDirective, {static: true}) public state;
  // ConfigGridLayout
  public optionsGridLocal = {
    cellSelection: true,
    rowSelection: false,
    filtering: false,
    advancedFiltering: true,
    paging: true,
    sorting: false,
    groupBy: true,
    columns: true,
    expansion: true,
    rowPinning: false,
    columnSelection: true
  };
  public vtnGenerico: VtnGenericaComponent;

  constructor() {
    super();
  }

  ngOnInit(): void {
    this.gridEmpresas.data = [];
  }

  public ngAfterViewInit() {
    // se genera la plantilla default del grid
    const stateDefault = this.state.getState(true);

    this.mObjConfigGrids.saveGridState(EnumNombresGrids.Empresas, true, stateDefault, '', this.clicked);
    const state = this.mObjConfigGrids.initGridState(EnumNombresGrids.Empresas);
    if (!ClsUtil.esNulo(state[0])) {
      this.state.setState(state[0]);
    }
    this.clicked = state[1];
    const result: { themesClass: string, clicked: boolean } = ClsUtil.ajustarTexto(this.clicked);
    this.themesClass = result.themesClass;
    this.clicked = result.clicked;
  }

  public onColumnInit(column: IgxColumnComponent) {
    switch (column.field) {
      case 'Empresa':
        column.headerTemplate = this.empresaTemplate;
        column.inlineEditorTemplate = this.empresaEditorTemplate;
        column.summaries = this.summaryPipe.transform('filasSummary');
        break;
      case 'RazonSocialEmpresa':
        column.headerTemplate = this.razonSocialEmpresaTemplate;
        column.inlineEditorTemplate = this.razonSocialEmpresaEditorTemplate;
        break;
      case 'DescripcionCiudad':
        column.inlineEditorTemplate = this.descripcionCiudadEditorTemplate;
        break;
      case 'DireccionEmpresa':
        column.inlineEditorTemplate = this.direccionEmpresaEditorTemplate;
        break;
      case 'Colonia':
        column.inlineEditorTemplate = this.coloniaEditorTemplate;
        break;
      case 'NombreResponsable':
        column.inlineEditorTemplate = this.nombreResponsableEditorTemplate;
        break;
      case 'TelefonoEmpresa':
        column.inlineEditorTemplate = this.telefonoEmpresaEditorTemplate;
        break;
      case 'RfcEmpresa':
        column.inlineEditorTemplate = this.rfcEmpresaEditorTemplate;
        break;
      case 'CodigoPostalEmpresa':
        column.inlineEditorTemplate = this.cpEmpresaEditorTemplate;
        break;
      case 'CMICEmpresa':
        column.inlineEditorTemplate = this.cMICEmpresaEditorTemplate;
        break;
      case 'FaxEmpresa':
        column.inlineEditorTemplate = this.faxEmpresaEditorTemplate;
        break;
      case 'IMSSEmpresa':
        column.inlineEditorTemplate = this.iMSSEmpresaEditorTemplate;
        break;
      case 'InfonavitEmpresa':
        column.inlineEditorTemplate = this.infonavitEmpresaEditorTemplate;
        break;
      case 'MailEmpresa':
        column.inlineEditorTemplate = this.mailEmpresaEditorTemplate;
        break;
      case 'SitioWeb':
        column.inlineEditorTemplate = this.sitioWebEditorTemplate;
        break;
    }
    // column.cellClasses = this.backgroundClasses;
  }

  public async cargarEmpresas(verMensajeEspera = true) {
    if (!ClsUtil.esNulo(this.infPpto.organizacion)) {
      try {
        if (verMensajeEspera) {
          this.tipoMsg.mostrarWaitDialog('MENSAJES.WAIT.GET_CATALOGOS');
        }
        this.mObjCRUDCatalogos.dataCatalogo = [];
        this.dataEmpresas = [];
        await this.mObjCRUDCatalogos.obtenerCatalogo(0, 'ConsultarEmpresas2021');
        this.mObjCRUDCatalogos.dataCatalogo.forEach(item => {
          const empresa: ClsEmpresas = {
            IdEmpresa: item.IdEmpresa,
            Empresa: item.Empresa,
            RazonSocialEmpresa: item.RazonSocialEmpresa,
            IdCiudadEmpresa: item.IdCiudadEmpresa,
            DescripcionCiudad: item.Ciudad.Ciudad,
            DireccionEmpresa: item.DireccionEmpresa,
            Colonia: item.Colonia,
            IdResponsableEmpresa: item.IdResponsableEmpresa,
            NombreResponsable: item.Responsable.Responsable,
            TelefonoEmpresa: item.TelefonoEmpresa,
            MailEmpresa: item.MailEmpresa,
            IMSSEmpresa: item.IMSSEmpresa,
            CMICEmpresa: item.CMICEmpresa,
            InfonavitEmpresa: item.InfonavitEmpresa,
            FaxEmpresa: item.FaxEmpresa,
            RfcEmpresa: item.RfcEmpresa,
            CodigoPostalEmpresa: item.CodigoPostalEmpresa,
            SitioWeb: item.SitioWeb,
          };
          this.dataEmpresas.push(empresa);
        });
        this.gridEmpresas.data = this.dataEmpresas;
        this.errorAlCargar = false;
      } catch (e) {
        this.errorAlCargar = true;
        this.tipoMsg.mostrarMsg(e.message, 'error');
      } finally {
        if (verMensajeEspera) {
          this.tipoMsg.cerrarWaitDialog();
        }
      }
    }
  }

  public clearInput() {
    this.filtroGeneral.input.value = '';
    this.gridEmpresas.clearFilter();
  }

  public menuContextual(evt: any) {
    evt.event.preventDefault();
    this.disableContextMenu();
    this.disableAllContextMenu();
    this.menus = this.mObjCRUDCatalogos.crearMenuContextual({
      esCliente: false,
      esUnidad: false,
      esEmpresa: true
    }, this.infPpto.esPptoMaestro);
    this.subMenusOpciones = [];
    this.lengthMenu = this.menus.filter(x => !x.disabled).length;
    this.contextmenuX = ClsUtil.calcPosition(document.body.clientWidth, evt.event.clientX, true, this.lengthMenu);
    this.contextmenuY = ClsUtil.calcPosition(document.body.clientHeight, evt.event.clientY, false, this.lengthMenu);
    this.sizeMenu = (this.lengthMenu * 37) + 'px';
    this.cellMenuContextaul = evt.cell;
    this.verContextMenu = true;
  }

  public disableContextMenu() {
    if (this.verContextMenu) {
      this.verContextMenu = false;
    }
  }

  public disableAllContextMenu() {
    this.mObjGenerico.disableAllContextMenu(this.infPpto);
  }

  public async accionSeleccionada(evt: INeodataGridCell) {
    try {
      switch (evt.accionMenu.id) {
        case EnumMCGenerales.DetalleEmpresa:
          const registro: ClsEmpresas = this.mObjCRUDCatalogos.dataCatalogo.find(value => ClsUtil.bigintX(value.IdEmpresa) === ClsUtil.bigintX(evt.dataSelected.row.data.IdEmpresa));
          const vtnGenerico = this.crearCompDinamico.crearComponente(VtnGenericaComponent).instance as VtnGenericaComponent;
          vtnGenerico.queVtnEstaAbierta = 'DetalleRegistro';
          const vtnDetallePartida = vtnGenerico.crearComponente(DetalleEmpresaComponent);
          vtnDetallePartida.registroSeleccionado = registro;
          vtnDetallePartida.open();
          break;
        case EnumMCGenerales.Copiar:
          await this.copiarData();
          break;
        case EnumMCGenerales.Pegar:
          let data: any = await navigator.clipboard.readText().then((data2) => data2);
          data = this.pasteHandlerNeo.processData(data);
          await this.datosPegadosDesdeExcel(data);
          break;
        case EnumMasOpciones.Ajustar:
          const result: { themesClass: string, clicked: boolean } = ClsUtil.ajustarTexto(this.clicked);
          this.themesClass = result.themesClass;
          this.clicked = result.clicked;
          break;
        case EnumMCGenerales.GuardarLayout:
          const state = this.state.getState(true);
          this.mObjConfigGrids.saveGridState(EnumNombresGrids.Empresas, false, '', state, !this.clicked);
          break;
        case EnumMCGenerales.ReestablecerLayout:
          this.restoreGrid();
          break;
      }
    } catch (e) {
      this.tipoMsg.mostrarMsg(e.message, 'error');
    }
  }

  public restoreGrid() {
    const stateDefault = this.mObjConfigGrids.restoreGrid(EnumNombresGrids.Empresas);
    if (!ClsUtil.esNulo(stateDefault[0])) {
      this.state.setState(stateDefault[0]);
    }
    this.clicked = stateDefault[1];
    const result: { themesClass: string, clicked: boolean } = ClsUtil.ajustarTexto(this.clicked);
    this.themesClass = result.themesClass;
    this.clicked = result.clicked;
  }

  public filterInput(filtro: string) {
    this.gridEmpresas.filteringLogic = FilteringLogic.Or;
    this.gridEmpresas.filterGlobal(filtro, IgxStringFilteringOperand.instance().condition('contains'), false);
  }

  public rowEditEnter() {
    this.showActionStrip = false;
  }

  public rowEditExit() {
    this.showActionStrip = true;
  }

  // evento que se ocupa para guardar o modificar
  public async addUpdateEmpresa(empresa: IGridEditDoneEventArgs) {
    const newValor: ClsEmpresas = empresa.newValue;
    const oldValor: ClsEmpresas = empresa.oldValue;
    if (!ClsUtil.esNulo(this.tresPuntosCiudad)) {
      newValor.IdCiudadEmpresa = this.tresPuntosCiudad.idDefault;
      newValor.DescripcionCiudad = this.tresPuntosCiudad.valorDefault;
    }
    if (!ClsUtil.esNulo(this.tresPuntosResp)) {
      newValor.IdResponsableEmpresa = this.tresPuntosResp.idDefault;
      newValor.NombreResponsable = this.tresPuntosResp.valorDefault;
    }
    if (empresa.isAddRow) {
      await this.agregarModificarEmpresa(newValor, oldValor, empresa.isAddRow);
    } else {
      // al editar los campos, validar que sean distintos para ocupar el servicio
      if (this.mObjCRUDCatalogos.validarSiCambioCamposCatalogos(newValor, oldValor, EnumTresPuntos.Empresas)) {
        await this.agregarModificarEmpresa(newValor, oldValor, empresa.isAddRow);
      }
    }
  }

  private async agregarModificarEmpresa(newEmpresa: ClsEmpresas, oldEmpresa: ClsEmpresas, isAddRow: boolean) {
    let respuesta: bigint;
    const objCatalogo: ClsEmpresas = new ClsEmpresas();
    try {
      objCatalogo.IdEmpresa = isAddRow ? ClsUtil.parseJSONBig(0) : newEmpresa.IdEmpresa;
      objCatalogo.Empresa = newEmpresa.Empresa.toUpperCase();
      objCatalogo.RazonSocialEmpresa = newEmpresa.RazonSocialEmpresa;
      objCatalogo.IdCiudadEmpresa = ClsUtil.esNulo(newEmpresa.IdCiudadEmpresa) ? ClsUtil.parseJSONBig(0) : newEmpresa.IdCiudadEmpresa;
      objCatalogo.DireccionEmpresa = ClsUtil.esNulo(newEmpresa.DireccionEmpresa) ? '' : newEmpresa.DireccionEmpresa;
      objCatalogo.Colonia = ClsUtil.esNulo(newEmpresa.Colonia) ? '' : newEmpresa.Colonia;
      objCatalogo.IdResponsableEmpresa = ClsUtil.esNulo(newEmpresa.IdResponsableEmpresa) ? ClsUtil.parseJSONBig(0) : newEmpresa.IdResponsableEmpresa;
      objCatalogo.TelefonoEmpresa = ClsUtil.esNulo(newEmpresa.TelefonoEmpresa) ? '' : newEmpresa.TelefonoEmpresa;
      objCatalogo.MailEmpresa = ClsUtil.esNulo(newEmpresa.MailEmpresa) ? '' : newEmpresa.MailEmpresa;
      objCatalogo.IMSSEmpresa = ClsUtil.esNulo(newEmpresa.IMSSEmpresa) ? '' : newEmpresa.IMSSEmpresa;
      objCatalogo.CMICEmpresa = ClsUtil.esNulo(newEmpresa.CMICEmpresa) ? '' : newEmpresa.CMICEmpresa;
      objCatalogo.InfonavitEmpresa = ClsUtil.esNulo(newEmpresa.InfonavitEmpresa) ? '' : newEmpresa.InfonavitEmpresa;
      objCatalogo.FaxEmpresa = ClsUtil.esNulo(newEmpresa.FaxEmpresa) ? '' : newEmpresa.FaxEmpresa;
      objCatalogo.RfcEmpresa = ClsUtil.esNulo(newEmpresa.RfcEmpresa) ? '' : newEmpresa.RfcEmpresa;
      objCatalogo.CodigoPostalEmpresa = ClsUtil.esNulo(newEmpresa.CodigoPostalEmpresa) ? '' : newEmpresa.CodigoPostalEmpresa;
      objCatalogo.SitioWeb = ClsUtil.esNulo(newEmpresa.SitioWeb) ? '' : newEmpresa.SitioWeb;
      this.tipoMsg.mostrarWaitDialog(isAddRow ? 'MENSAJES.WAIT.GUARDANDO_CATALOGO' : 'MENSAJES.WAIT.MODIFICANDO_CATALOGO');
      respuesta = await this.mObjCRUDCatalogos.agregarModificarCatalogo([objCatalogo], 'EmpresasRegistraActualiza2021');
      // if (isAddRow) {
      //   newEmpresa.IdEmpresa = respuesta;
      // }
      await this.cargarEmpresas(false);
      this.tipoMsg.mostrarToast(isAddRow ? 'MENSAJES.TOAS.GUARDANDO_CATALOGO' : 'MENSAJES.TOAS.MODIFICANDO_CATALOGO');
      this.tresPuntosCiudad = undefined;
      this.tresPuntosResp = undefined;
      this.tipoMsg.cerrarWaitDialog();
    } catch (e) {
      this.tipoMsg.cerrarWaitDialog();
      this.cancelarAddUpdateEmpresas(newEmpresa, oldEmpresa, isAddRow);
      this.tipoMsg.mostrarMsg(e.message, 'error');
    }
  }

  // se ocupa cuando manda error al intentar agregar o modificar,
  // al agregar si manda error se quita la fila del grid
  // al editar si manda error se regresa a los valores anteriores
  private cancelarAddUpdateEmpresas(newEmpresa: ClsEmpresas, oldEmpresa: ClsEmpresas, isAddRow: boolean) {
    if (isAddRow) {
      this.gridEmpresas.deleteRowById(newEmpresa.IdEmpresa);
    } else {
      this.gridEmpresas.updateRow(oldEmpresa, oldEmpresa.IdEmpresa);
    }
    this.tresPuntosCiudad = undefined;
    this.tresPuntosResp = undefined;
  }

  private async eliminarEmpresas(rowContext: RowType) {
    const empresa: ClsEmpresas = rowContext.data;
    try {
      this.tipoMsg.mostrarWaitDialog('MENSAJES.WAIT.ELIMINANDO_CATALOGO', undefined, 'delete');
      await this.mObjCRUDCatalogos.eliminarCatalogo(empresa.IdEmpresa, 'EliminarEmpresas2021');
      this.gridEmpresas.getRowByIndex(rowContext.index).delete();
      this.tipoMsg.mostrarToast('MENSAJES.TOAS.ELIMINANDO_CATALOGO');
      this.tipoMsg.cerrarWaitDialog();
    } catch (e) {
      this.tipoMsg.cerrarWaitDialog();
      this.tipoMsg.mostrarMsg(e.message, 'error');
    }
  }

  // se ocupa el evento rowEdit para validar uno o varios campos obligatorios,
  // si falta algun campo de todo la fila se cancela la edicio y se manda mensaje que campos faltan
  // en caso de ser todo OK, procede al agregado o modificado
  public validarEmpresa(empresa: IGridEditEventArgs) {
    const valor: ClsEmpresas = empresa.newValue;
    empresa.cancel = this.esValido(valor, empresa, empresa.isAddRow);
    // this.gridEmpresas.navigateTo(empresa.rowKey, 0, (obj) => {
    //   obj.target.nativeElement.focus();
    // });
  }

  // en este caso se pasa el valor de la empresa, ya que es el unico campo obligatorio,
  // en caso de ser mas campos a validar, pasar toda la clase
  private esValido(empresa: ClsEmpresas, emp: any, isAddRow: boolean): boolean {
    // validar campos obligatorios
    if (ClsUtil.esNulo(empresa.Empresa)) {
      this.tipoMsg.mostrarMsg(this.mObjGenerico.getTranslationsAlertValidarCampos(this.mObjGenerico.getTranslationValidarColuma('GRIDS.EMPRESA.COL_EMPRESA')));
      return true;
    }
    if (ClsUtil.esNulo(empresa.RazonSocialEmpresa)) {
      this.tipoMsg.mostrarMsg(this.mObjGenerico.getTranslationsAlertValidarCampos(this.mObjGenerico.getTranslationValidarColuma('GRIDS.EMPRESA.COL_RS')));
      return true;
    }
    // valida si ya existe la empresa cuando se agrega o modifica
    if (isAddRow) {
      if (this.dataEmpresas.findIndex(empresa2 => empresa2.Empresa === empresa.Empresa) !== -1) {
        this.tipoMsg.mostrarMsg(this.mObjGenerico.getTranslationsAlertRegistroExistente(empresa.Empresa));
        return true;
      }
    } else {
      if (empresa.Empresa !== emp.oldValue.Empresa) {
        if (this.dataEmpresas.findIndex(empresa2 => empresa2.Empresa === empresa.Empresa) !== -1) {
          this.tipoMsg.mostrarMsg(this.mObjGenerico.getTranslationsAlertRegistroExistente(empresa.Empresa));
          return true;
        }
      }
    }
    return false;
  }

  public accionStripRowBtn(rowContext: RowType, indexBtn: number) {
    try {
      switch (indexBtn) {
        case 1:
          this.beginAddRowByIndexNeo(this.gridEmpresas, rowContext.index);
          break;
        case 2:
          this.tipoMsg.mostrarQuestion(async (resp: boolean) => {
            if (resp) {
              await this.eliminarEmpresas(rowContext);
            }
          }, this.mObjGenerico.getTranslationsQuestionBorrar(rowContext.data.Empresa));
          break;
      }
    } catch (e) {
      this.tipoMsg.mostrarMsg(e.message, 'error');
    }
  }

  public async onSelectionDropDown(opcion: string) {
    try {
      switch (opcion) {
        case EnumMasOpciones.Ajustar:
          const result: { themesClass: string, clicked: boolean } = ClsUtil.ajustarTexto(this.clicked);
          this.themesClass = result.themesClass;
          this.clicked = result.clicked;
          break;
        case EnumMasOpciones.ExportarExcel:
          const sms = await ClsUtil.exportarDatos(this.gridEmpresas, this.mObjGenerico.getTranslationsGetCatalogos('MENSAJES.GRALS.EMPRESAS'), this.excelExportService).then(sms => { return sms });
          this.tipoMsg.mostrarToast(this.mObjGenerico.getTranslationsSmsExportar(sms, this.gridEmpresas.selectedRows.length));
          break;
        case EnumMasOpciones.ExportarPDF:
          await ClsUtil.abrirVentanaPersonalizarPDF(
            this.gridEmpresas,
            this.mObjGenerico.getTranslationsGetCatalogos('MENSAJES.GRALS.EMPRESAS'),
            this.pdfExportService,
            this.crearCompDinamico,
            this.tipoMsg,
            this.mObjGenerico
          );
          break;
        case EnumMasOpciones.Actualizar:
          await this.cargarEmpresas();
          break;
        case EnumMasOpciones.LimpiarFiltroColumnas:
          this.clearInput();
          break;
      }
    } catch (e) {
      this.tipoMsg.mostrarMsg(e.message, 'error');
    }
  }

  public async onOpenDesCiudad(input: HTMLInputElement, data: ClsEmpresas) {
    const selectRows: any = [this.tresPuntosCiudad?.idDefault];
    this.tresPuntosCiudad = this.crearCompDinamico.crearComponente(TresPuntosComponent).instance as TresPuntosComponent;
    this.tresPuntosCiudad.tipoCatalogo = EnumTresPuntos.Ciudades;
    this.tresPuntosCiudad.selectedRows = selectRows;
    await this.tresPuntosCiudad.onOpen();
    this.tresPuntosCiudad.eventFilaSeleccionada.subscribe((valor: ClsCiudades) => {
      input.value = valor.Ciudad
      this.gridEmpresas.updateCell(valor.Ciudad.toUpperCase(), data.IdEmpresa, 'DescripcionCiudad');
      setTimeout(() => {
        input.focus();
      }, 5);
    });
  }

  public async onOpenRes(input: HTMLInputElement, data: ClsEmpresas) {
    const selectRows: any = [this.tresPuntosResp?.idDefault];
    this.tresPuntosResp = this.crearCompDinamico.crearComponente(TresPuntosComponent).instance as TresPuntosComponent;
    this.tresPuntosResp.tipoCatalogo = EnumTresPuntos.Responsables;
    this.tresPuntosResp.selectedRows = selectRows;
    await this.tresPuntosResp.onOpen();
    this.tresPuntosResp.eventFilaSeleccionada.subscribe((valor: ClsResponsables) => {
      input.value = valor.Responsable;
      this.gridEmpresas.updateCell(valor.Responsable.toUpperCase(), data.IdEmpresa, 'NombreResponsable');
      setTimeout(() => {
        input.focus();
      }, 5);
    });
  }

  public handleRowSelection() {
    this.gridEmpresas.nativeElement.focus();
  }

  public async datosPegadosDesdeExcel(datosPegado: any[]) {
    try {
      this.tipoMsg.mostrarWaitDialog('MENSAJES.WAIT.PEGANDO');
      let arrayEmpresas: ClsEmpresas[] = [];
      let dataDetalle: ClsColDetallePegado[];
      const colEmpresa: string[] =
        [this.mObjGenerico.getTranslationsSubject('GRIDS.EMPRESA.COL_EMPRESA'),
          this.mObjGenerico.getTranslationsSubject('GRIDS.EMPRESA.COL_RS'),
          this.mObjGenerico.getTranslationsSubject('GRIDS.EMPRESA.COL_CIUDAD'),
          this.mObjGenerico.getTranslationsSubject('GRIDS.EMPRESA.COL_DIRECCION'),
          this.mObjGenerico.getTranslationsSubject('GRIDS.EMPRESA.COL_COLONIA'),
          this.mObjGenerico.getTranslationsSubject('GRIDS.EMPRESA.COL_RESPONSABLE'),
          this.mObjGenerico.getTranslationsSubject('GRIDS.EMPRESA.COL_TELEFONO'),
          'RFC',
          this.mObjGenerico.getTranslationsSubject('GRIDS.EMPRESA.COL_CP'),
          'CMIC',
          'Fax',
          'IMSS',
          'Infonavit',
          'Mail',
          this.mObjGenerico.getTranslationsSubject('GRIDS.EMPRESA.COL_SITIO_WEB')];
      this.mObjCopiado.columnasRequeridas = [colEmpresa[0], colEmpresa[1]];
      if (this.mObjCopiado.validarCamposRequeridos(datosPegado)) {
        let datos = this.mObjCopiado.procesarDatos(datosPegado, true);
        datos = this.mObjPegado.mergeDescriptions(datos, EnumNombresGrids.Empresas);
        dataDetalle = this.mObjPegado.verificarDetallePegado(datos, colEmpresa, [colEmpresa[0], colEmpresa[1]], EnumNombresGrids.Empresas, this.mObjGenerico);
        if (dataDetalle.length > 0) {
          const vtnGenerico = this.crearCompDinamico.crearComponente(VtnGenericaComponent).instance as VtnGenericaComponent;
          vtnGenerico.queVtnEstaAbierta = 'PegadoEspecial';
          const vtnDiferencia = vtnGenerico.crearComponente(DetallePegadoComponent);
          vtnDiferencia.dataDetalle = dataDetalle;
          vtnDiferencia.open();
        } else {
          datos.forEach(x => {
            const valEmpresa: string[] = [
              (x[colEmpresa[0]] as string).toUpperCase(),
              ClsUtil.cadenaX(x[colEmpresa[1]] as string),
              ClsUtil.cadenaX(x[colEmpresa[2]] as string).toUpperCase(),
              ClsUtil.cadenaX(x[colEmpresa[3]] as string),
              ClsUtil.cadenaX(x[colEmpresa[4]] as string),
              ClsUtil.cadenaX(x[colEmpresa[5]] as string).toUpperCase(),
              ClsUtil.cadenaX(x[colEmpresa[6]] as string),
              ClsUtil.cadenaX(x[colEmpresa[7]] as string),
              ClsUtil.cadenaX(x[colEmpresa[8]] as string),
              ClsUtil.cadenaX(x[colEmpresa[9]] as string),
              ClsUtil.cadenaX(x[colEmpresa[10]] as string),
              ClsUtil.cadenaX(x[colEmpresa[11]] as string),
              ClsUtil.cadenaX(x[colEmpresa[12]] as string),
              ClsUtil.cadenaX(x[colEmpresa[13]] as string),
              ClsUtil.cadenaX(x[colEmpresa[14]] as string)];
            const resp: any = this.mObjCRUDCatalogos.crearObjCatalogos(this.dataEmpresas, valEmpresa, colEmpresa, EnumTresPuntos.Empresas, this.mObjGenerico);
            if (!ClsUtil.esNulo(resp.esNuevo)) {
              if (resp.esNuevo) {
                arrayEmpresas.push(resp.obj);
              } else {
                this.gridEmpresas.updateCell(valEmpresa[0], resp.obj.IdEmpresa, 'Empresa');
                this.gridEmpresas.updateCell(valEmpresa[1], resp.obj.IdEmpresa, 'RazonSocialEmpresa');
                this.gridEmpresas.updateCell(valEmpresa[2], resp.obj.IdEmpresa, 'DescripcionCiudad');
                this.gridEmpresas.updateCell(valEmpresa[3], resp.obj.IdEmpresa, 'DireccionEmpresa');
                this.gridEmpresas.updateCell(valEmpresa[4], resp.obj.IdEmpresa, 'Colonia');
                this.gridEmpresas.updateCell(valEmpresa[5], resp.obj.IdEmpresa, 'NombreResponsable');
                this.gridEmpresas.updateCell(valEmpresa[6], resp.obj.IdEmpresa, 'TelefonoEmpresa');
                this.gridEmpresas.updateCell(valEmpresa[7], resp.obj.IdEmpresa, 'RfcEmpresa');
                this.gridEmpresas.updateCell(valEmpresa[8], resp.obj.IdEmpresa, 'CodigoPostalEmpresa');
                this.gridEmpresas.updateCell(valEmpresa[9], resp.obj.IdEmpresa, 'CMICEmpresa');
                this.gridEmpresas.updateCell(valEmpresa[10], resp.obj.IdEmpresa, 'FaxEmpresa');
                this.gridEmpresas.updateCell(valEmpresa[11], resp.obj.IdEmpresa, 'IMSSEmpresa');
                this.gridEmpresas.updateCell(valEmpresa[12], resp.obj.IdEmpresa, 'InfonavitEmpresa');
                this.gridEmpresas.updateCell(valEmpresa[13], resp.obj.IdEmpresa, 'MailEmpresa');
                this.gridEmpresas.updateCell(valEmpresa[14], resp.obj.IdEmpresa, 'SitioWeb');
                arrayEmpresas.push(resp.obj);
              }
            }
          });
          // invocar servicio para agregar o modificar siempre y cuando el arrayUnidades tenga valor
          if (arrayEmpresas.length > 0) {
            const respuesta: any = await this.mObjCRUDCatalogos.agregarModificarCatalogo(arrayEmpresas, 'EmpresasRegistraActualizaCod', false);
            // filtro los registros con id 0
            arrayEmpresas = arrayEmpresas.filter(value => value.IdEmpresa === BigInt(0));
            // iteramos la respuesta para ir asignando los ids para los registros nuevos
            const key: string[] = Object.keys(respuesta);
            key.forEach(x => {
              const emp: ClsEmpresas = arrayEmpresas.find(value1 => value1.Empresa === x);
              if (!ClsUtil.esNulo(emp)) {
                emp.IdEmpresa = ClsUtil.bigintX(respuesta[x]);
                this.gridEmpresas.addRow(emp);
              }
            });
          }
        }
      }
    } catch (e) {
      this.tipoMsg.mostrarMsg(e.message);
    } finally {
      this.tipoMsg.cerrarWaitDialog();
    }
  }

  public async customKeydown(eventArgs: any) {
    const ctrl = eventArgs.ctrlKey;
    const key = eventArgs.keyCode;
    // Ctrl-C ||  Cmd-C
    if ((ctrl || eventArgs.metaKey) && key === 67) {
      await this.copiarData();
    }
  }

  public async copiarData() {
    try {
      this.tipoMsg.mostrarWaitDialog('MENSAJES.WAIT.COPIANDO');
      const msg: string = await ClsUtil.copiarDatosGrids(this.gridEmpresas, 'IdEmpresa', this.mObjGenerico);
      msg && this.tipoMsg.mostrarToast(msg);
    } catch (e) {
      throw new Error(e.message);
    } finally {
      this.tipoMsg.cerrarWaitDialog();
    }
  }

  public clearProps() {
    this.gridEmpresas.clearSort();
    this.gridEmpresas.clearFilter();
    this.gridEmpresas.clearSearch();
    this.gridEmpresas.deselectAllRows();
    this.clearInput();
  }

  public registroSeleccionado() {
    const rowSeleccionados: bigint[] = this.gridEmpresas.selectedRows;
    try {
      if (rowSeleccionados.length === 0) {
        throw new Error('MENSAJES.ALERT.SELECCIONAR_REGISTRO');
      }
      const rowData = this.gridEmpresas.getRowData(rowSeleccionados[0]);
      this.gridEmpresas.doubleClick.emit(rowData);
    } catch (e) {
      this.tipoMsg.mostrarMsg(e.message, 'error');
    }
  }
}
